import { Box, Flex } from "@chakra-ui/react";
import { KPSLogoBig } from "@root/assets/icons";
import { CollapseIcon } from "@root/assets/icons/collapseicon";
import SidebarHeaderIcon from "@root/assets/sidebarheadericon";
import { useGlobalContext } from "@root/context/global-context";

export function SidebarHeader({ lg, isOpen, isDarkTheme }: any) {
  const { isSidebarOpen, setIsSidebarOpen } = useGlobalContext();
  const toggleSidebar = () => {
    setIsSidebarOpen((prev: any) => !prev);
  };

  return (
    <Flex
      flexDirection="column"
      py="2"
      pb="3"
      borderBottom="1px solid"
      borderColor="gray.200"
      minH="70px"
      justifyContent="center"
    >
      {/* Sidebar Header Icon - Only shown when collapsed */}
      {!isSidebarOpen && (
        <Flex justifyContent="center" alignItems="center">
          <SidebarHeaderIcon
            onClick={toggleSidebar}
            cursor={"pointer"}
            width={20}
            height={20}
          />
        </Flex>
      )}

      {/* KPS Logo and Collapse Icon - Shown when expanded */}
      {isSidebarOpen && (
        <Flex
          alignItems="center"
          justifyContent="space-between"
          flexDirection="row"
          marginRight="-32px"
        >
          <KPSLogoBig width={178} height={54} />
          <Box mr="26px" cursor={"pointer"} onClick={toggleSidebar}>
            <CollapseIcon width={40} height={40} />
          </Box>
        </Flex>
      )}
    </Flex>
  );
}
